import axios from "axios";
import { Dispatch } from "redux";
import { Payload } from "@neworbit/redux-helpers";

import { loadAndTrack } from "redux-request-loading";

import { DataExtract } from "./models";
import { DataExtractApi } from "./DataExtractApi";
import {
    CREATE_EMPLOYEE_DATA_EXTRACT,
    LOAD_DATA_EXTRACTS_SUCCESS,
    CREATE_DATA_EXTRACT_SUCCESS,
    CREATE_CUSTOMER_DATA_EXTRACT,
    LOAD_DATA_EXTRACTS
} from "./actionTypes";

type CreateDataExtractSuccessAction = { type: typeof CREATE_DATA_EXTRACT_SUCCESS } & Payload<DataExtract>;
type LoadDataExtractsSuccessAction = { type: typeof LOAD_DATA_EXTRACTS_SUCCESS } & Payload<DataExtract[]>;
export type DataExtractAction = CreateDataExtractSuccessAction | LoadDataExtractsSuccessAction;

export const createCustomerDataExtract = buildCreateCustomerDataExtract(new DataExtractApi(axios));

export function buildCreateCustomerDataExtract(dataExtractApi: DataExtractApi) {
    return (customerId: string) => {
        return async (dispatch: Dispatch) => {
            const result = await loadAndTrack(dispatch, CREATE_CUSTOMER_DATA_EXTRACT, dataExtractApi.createCustomer(customerId));
            dispatch(createDataExtractSuccess(result));
        };
    };
}

export const createEmployeeDataExtract = buildCreateEmployeeDataExtract(new DataExtractApi(axios));

export function buildCreateEmployeeDataExtract(dataExtractApi: DataExtractApi) {
    return (customerId: string, employeeId: string) => {
        return async (dispatch: Dispatch) => {
            const result = await loadAndTrack(dispatch, CREATE_EMPLOYEE_DATA_EXTRACT, dataExtractApi.createEmployee(customerId, employeeId));
            dispatch(createDataExtractSuccess(result));
        };
    };
}

export const createDataExtractSuccess = (payload: DataExtract): CreateDataExtractSuccessAction => ({
    type: CREATE_DATA_EXTRACT_SUCCESS,
    payload
});

export const loadDataExtracts = buildLoadDataExtracts(new DataExtractApi(axios));

export function buildLoadDataExtracts(dataExtractApi: DataExtractApi) {
    return () => {
        return async (dispatch: Dispatch) => {
            const result = await loadAndTrack(dispatch, LOAD_DATA_EXTRACTS, dataExtractApi.loadAll());
            dispatch(loadDataExtractsSuccess(result));
        };
    };
}

export const loadDataExtractsSuccess = (payload: DataExtract[]): LoadDataExtractsSuccessAction => ({
    type: LOAD_DATA_EXTRACTS_SUCCESS,
    payload
});
